import React, { Component, PropTypes } from 'react';

import './formField.scss';

export default class FormField extends Component {

    static contextTypes = {
        intl: PropTypes.object
    }

    render() {
        let {className, label, children} = this.props;
        return (
            <div className={`form-field ${className ? className : ""}`}>
                <If condition={label}>
                    <div className="form-field-label">
                        <div className="form-field-label-text">
                            {label}
                        </div>
                    </div>
                </If>
                <div className="form-field-content">
                    {children}
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/views/formField/FormField.js